<template>
    <div class="row">
        <div class="col-md-3">
            <DateIconGroup :idInput="'inicio-' + tag" iconInput="fa-calendar" labelInput="Data de inicio" :enableTime="true">
                &nbsp;
            </DateIconGroup>
        </div>
        <div class="col-md-3">
            <InputIconGroup typeInput="number" :idInput="'quantidade_aulas-' + tag" 
            iconInput="fa-info" labelInput="Quantidade de Aulas" :min="1" :max="10">
                &nbsp;
            </InputIconGroup>
        </div>
        <div class="col-md-2">
            <SelectIconGroup :idInput="'id_instrutor-' + tag" iconInput="fa-pencil" labelInput="Instrutor"
            :optionsInput="optionsInputInstrutor" :optionSelected="optionSelectedInstrutor" style="padding-bottom: 4px;">
            </SelectIconGroup>
        </div>
        <div class="col-md-2">
            <SelectIconGroup :idInput="'id_materia-' + tag" iconInput="fa-columns" labelInput="Materia" 
            :optionsInput="optionsInputMateria" :optionSelected="optionSelectedMateria"
            style="padding-bottom: 4px;">
            </SelectIconGroup>
        </div>
        <div class="col-md-2">
            <SelectIconGroup :idInput="'id_sala-' + tag" iconInput="fa-pencil" labelInput="Sala"
            :optionsInput="optionsInputSalas" style="padding-bottom: 4px;">
            </SelectIconGroup>
        </div>
    </div>
</template>

<script>
    import TurmasController from './TurmasController'
    import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
    import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
    import InputUploadGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputUploadGroup'
    import InputCheckboxGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputCheckboxGroup'
    import SelectIconGroup from '../../vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'


    export default {
        name: 'input-aula',
        components: {
            SelectIconGroup,
            InputUploadGroup,
            InputIconGroup,
            InputCheckboxGroup,
            DateIconGroup,

        },
        data () {
            return {
            content: {
                load: true
            },
            optionsInputInstrutor: [{
                id: '',
                value: 'Selecione um instrutor'
            }],
            optionSelectedInstrutor: '',
            optionsInputMateria: [{
                id: '',
                value: 'Selecione uma materia'
            }],
            optionsInputSalas: [{
                id: '',
                value: 'Selecione uma sala'
            }],
            optionSelectedMateria: '',
            tag: 1
            }
        },

        mounted(){
            let self = this

            TurmasController.getInstrutores(function (data) {
                data.dados.map(function (value) {
                    self.optionsInputInstrutor.push({ id: value.id_instrutor, value: value.nome })
                })
            })

            TurmasController.getMaterias(function (data) {
                data.dados.map(function (value) {
                    self.optionsInputMateria.push({ id: value.id_materia, value: value.titulo })
                })
            })

            TurmasController.getSalas(function (data) {
                data.dados.map(function (value) {
                    self.optionsInputSalas.push({ id: value.id_sala, value: value.sala })
                })
            })

            if(self.$route){
                if (self.$route.params.idTurma) {
                    TurmasController.carregaFormularioDeAula(self.$route.params.idTurma)
                }  
            }  
        },

        methods:{
            addTag(i){
                this.tag = i;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>